import { Helmet } from 'react-helmet-async';
import './home.css';
import Services from "../../components/services/services";
import Form from "../../components/form/form";
import Gallery from "../../components/gallery/gallery";
import WhyHIM from "../../components/whyUs/why-us";
import HowWeWork from "../../components/howWeWork/how-we-work";
import Testimonial from "../../components/testimonial/testimonial";
import FloatingCTA from "../../components/floatingCTA/floatingCTA";

const Home = () =>{
    return(
        <div className="home-container">

            <Helmet>
                <title>Handyman in Melbourne | Residential & Commercial Repairs</title>
                <meta name="description" content="Handyman in Melbourne for homes, businesses and commercial properties. Book repairs, installations and property maintenance. Call 0412 279 273 for a quote." />
                <link rel="canonical" href="https://handymaninmelbourne.au/" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Handyman in Melbourne | Residential & Commercial Repairs" />
                <meta property="og:description" content="Local Melbourne handyman for homes, businesses and commercial properties. Repairs, installations and property maintenance." />
                <meta property="og:url" content="https://handymaninmelbourne.au/" />
                <meta property="og:image" content="https://handymaninmelbourne.au/static/images/branding/handyman-in-melbourne-social-share.png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Handyman in Melbourne | Residential & Commercial Repairs" />
                <meta name="twitter:description" content="Local Melbourne handyman for homes, businesses and commercial properties. Repairs, installations and property maintenance." />
                <meta name="twitter:image" content="https://handymaninmelbourne.au/static/images/branding/handyman-in-melbourne-social-share.png" />
            </Helmet>
             
            <div className="hero">
                <video className="hero-video" autoPlay loop muted playsInline>
                    <source src="/static/videos/picture-hanging-levelling.mp4" type="video/mp4" />
                </video>
                <div className="hero-overlay"></div>
                <div className="hero-inner">
                    <p className="tagline">Done Right • The First Time</p>
                    <h1 className="hero-title">Reliable Handyman in Melbourne for the jobs you keep putting off.</h1>
                    <p className="subtext">Professional handyman services for homes and businesses across Melbourne.</p>
                    <div className="button-row">
                        <button className="btn-primary"><a href="tel:0412279273" className="new-a">📞 Call Now</a></button>
                        <button className="btn-secondary"><a href="#contact-form" className="new-a">Book a Job</a></button>
                    </div>
                </div>
            </div>

            <div className="home-inner">
                <section className="section-gap">
                    <h2 className="home-h2">Our Services</h2>
                    <Services />
                </section>
                
                <section className="section-padding">
                    <h2 className='home-h2'>Why Choose Handyman In Melbourne</h2>
                    <WhyHIM />
                </section>

                <section className="section-padding">
                    <h2 className="home-h2">Simple. Fast. Hassle-Free.</h2>
                    <HowWeWork />
                </section>
                
                <section className="section-padding">
                    <h2 className='home-h2'>Recent Works</h2>
                    <Gallery />
                </section>

                <section className="section-padding">
                    <h2 className="home-h2">What Our Customer Say</h2>
                    <Testimonial />
                </section>
                
                <section className="section-padding" id="contact-form">
                    <Form />
                </section>

                <section className="section-padding">
                    <h2 className="home-h2">Areas We Serve</h2>
                    <p className="service-map-p">
                        We offer Professional Handyman services in most suburbs of Melbourne.
                        Check the map below to see if your neighbourhood is inside our service boundary.
                    </p>
                    <p className="service-map-p">
                        Not sure? Ask us anyway.
                    </p>
                    <iframe title="Map of our location" src="https://www.google.com/maps/d/u/4/embed?mid=1QPzQ2ZyOs7D2WABikqhqVzQQ68J5sxQ&ehbc=2E312F" width="100%" height="480" />
                </section>
            </div>

            <div className="footer-cta">
                <div className="footer-cta-inner">

                    <div className="footer-cta-content">
                        <h2 className="footer-cta-h2">Need a Reliable Handyman Today?</h2>
                        <p className="footer-cta-p">Get in touch for a free quote. We're ready to help.</p>
                    </div>
                    <div className="button-row button-row-footer">
                        <button className="btn-primary">
                            <a href="tel:0412279273" className="new-a">
                                📞 0412 279 273
                            </a>
                        </button>
                        <button className="btn-secondary">
                            <a href="sms:0412279273" className="new-a">
                                💬 Text / SMS
                            </a>
                        </button>

                        
                    </div>
                </div>
            </div>

            <FloatingCTA />
        </div>
    )
}

export default Home;
